import { changeKeys } from "../plan/keys";
/**
 * Query keys for the profile sections (`../core/keys.ts` is the convention).
 *
 * One key per SECTION, each a single resource the server replaces whole, so a
 * section's `PUT` invalidates its own read and never a sibling's: saving the
 * equipment checklist must not refetch the injury map a second editor has
 * open. The measurement series is keyed per kind and range; its writes reach
 * every kind (`measurementsAll`), because the server normalises `kind` and the
 * client cannot know which spelling a series is cached under.
 */
export const profileKeys = {
    all: ["profile"],
    profile: ["profile", "athlete"],
    trainingConfig: ["profile", "training-config"],
    equipment: ["profile", "equipment"],
    /** The saved gyms (`D202`) — a sibling of the equipment, never under it:
     *  a checklist save must not refetch the list of presets. */
    gyms: ["profile", "gyms"],
    injuries: ["profile", "injuries"],
    parq: ["profile", "parq"],
    measurements: (kind, from, to) => ["profile", "measurements", kind, from ?? null, to ?? null],
    measurementsAll: ["profile", "measurements"],
    /**
     * `GET /me/measurement-summary` (`D207`), keyed OUTSIDE `measurementsAll`
     * on purpose: the outbox's optimistic patch rewrites every entry under that
     * prefix as a one-kind series (`applyMeasurement`), and a summary is not
     * one. The measurement writes invalidate it by name instead.
     */
    measurementSummary: (family) => ["profile", "measurement-summary", family],
    measurementSummaryAll: ["profile", "measurement-summary"],
    onboarding: ["profile", "onboarding"],
};
/**
 * What every profile write invalidates besides its own section: the two reads
 * DERIVED from all of them. `GET /me/onboarding` is computed from which
 * sections are stored (Session 1's answers go through these very `PUT`s), and
 * `GET /me/changes` is the account's history, which records each write. Neither
 * is a sibling section, so "only that section" still holds for the sections.
 */
export function profileWriteInvalidates(section) {
    return [section, profileKeys.onboarding, changeKeys.all];
}
//# sourceMappingURL=keys.js.map